import { render, staticRenderFns } from "./SpecialistModal.vue?vue&type=template&id=8f8580ea&scoped=true&"
import script from "./SpecialistModal.vue?vue&type=script&lang=ts&"
export * from "./SpecialistModal.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialistModal.vue?vue&type=style&index=0&id=8f8580ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8580ea",
  null
  
)

export default component.exports